import BasePopupHandler from './BasePopupHandler';
import UIItem, { ITextData } from '../../../Prototype/UI/UIItem';
import GameObject from '../../../GameObject/GameObject';
import BaseUISystem from '../BaseUISystem';
import CrossPromoDriver, {
    CrossPromoAssetType,
} from '../../../Utility/CrossPromo/CrossPromoDriver';
import Element from '../../../Prototype/UI/Element';
import CrossPromoImage from '../../../Prefabs/UI/CrossPromo/CrossPromoImage';
import CrossPromoCampaign from '../../../Utility/CrossPromo/CrossPromoCampaign';
import { PopupID } from '../../../State/UI/PopupID';

export default class CrossPromoMenuHandler extends BasePopupHandler {
    public campaign: CrossPromoCampaign;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.CROSS_PROMO_MENU, uiSystem);
    }

    protected createPopup(params?: any): void {
        this.submitBtnParams.text.textLocalizationKey = 'InviteCTA';

        super.createPopup({
            buttons: [this.closeBtnParams, this.submitBtnParams],
            title: 'NewGame',
        });

        const description: GameObject<PIXI.Container> = UIItem.createText(
            this.descriptionParams
        );
        this.background.addChild(description);
    }
    public onShow(params: any): void {
        super.onShow(params);

        this.campaign = params;

        const crossPromoImage: Element = GameObject.Instantiate(
            CrossPromoImage,
            {
                layout: {
                    anchors: [0.5, 0.42, 0.5, 0.42],
                },
                cacheKey: this.campaign.getAssetKey(
                    CrossPromoAssetType.LANDSCAPE_IMAGE
                ),
                imageType: CrossPromoAssetType.LANDSCAPE_IMAGE,
                scale: 1.15,
            }
        );
        this.element.addChild(crossPromoImage);
    }
    public onSubmit(): void {
        super.onSubmit();
        if (this.campaign) {
            CrossPromoDriver.switchGame(this.campaign.id);
        }
    }
    protected descriptionParams: ITextData = {
        name: 'description',
        textLocalizationKey: 'XPromoDescription',
        layout: {
            anchors: [0.5, 0.67, 0.5, 0.67],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#bb3c2f',
            fontSize: '55px',
        },
        bounds: [520, 100],
    };
}
